<template>
  <RevAccordionItem>
    <template #prefix><slot /></template>
    <template #title>
      <RevSkeleton height="20px" shape="rectangle" width="140px" />
    </template>
    <template #description>
      <RevSkeleton class="mt-4" height="16px" shape="rectangle" width="240px" />
    </template>
  </RevAccordionItem>
</template>

<script setup lang="ts">
import { RevAccordionItem } from '@ds/components/AccordionItem'
import { RevSkeleton } from '@ds/components/Skeleton'
</script>
